<template>
  <div>
    <b-nav-item-dropdown :right="right" :no-caret="noCaret" class="mr-3 profile" v-if="id!=null">
      <template slot="button-content">
        <slot name="header">&#10068;</slot>
      </template>
      <slot name="dropdown">
        <div :style="{ right: 'auto', height: '200px' }">
          <span class="text-center">dropdown</span>
        </div>
      </slot>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown :right="right" :no-caret="noCaret" class="mr-3 profile" v-else>
      <template slot="button-content">
        <slot name="signin">&#10068;</slot>
      </template>
      <b-dropdown-item>
        <router-link to="/login">
          <i class="fa fa-lock" /> Sign in
        </router-link>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>
<script>
export default {
  name: "HeaderDropdown",
  data() {
    return {};
  },
  props: {
    right: {
      type: Boolean,
      default: false
    },
    noCaret: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    id() {
      return this.$store.getters["auth/getUserID"];
    }
  },
  mounted() {}
};
</script>
<style>
.profile {
  background: #EAEEFD;
  border-radius: 8px;
  padding: 8px 0px
}
.profile img {
  height: 35px;
  width: 35px;
  line-height: 35px;
  margin: 0px;
}
.app-header .dropdown-item {
  min-width: 170px;
}
</style>
